var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.387465 0.387464C0.904084 -0.129155 1.74169 -0.129155 2.25831 0.387465L6 4.12916L9.74169 0.387465C10.2583 -0.129155 11.0959 -0.129155 11.6125 0.387465C12.1292 0.904084 12.1292 1.74169 11.6125 2.25831L7.87084 6.00001L11.6125 9.74169C12.1291 10.2583 12.1291 11.0959 11.6125 11.6125C11.0959 12.1292 10.2583 12.1292 9.74168 11.6125L6 7.87085L2.25832 11.6125C1.7417 12.1292 0.904095 12.1292 0.387476 11.6125C-0.129143 11.0959 -0.129143 10.2583 0.387476 9.74169L4.12916 6.00001L0.387464 2.25831C-0.129155 1.74169 -0.129155 0.904084 0.387465 0.387464Z",
    fill: "#081754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3c4da7d2715bfe3915289d3af37d8e99.svg";
export { ForwardRef as ReactComponent };